import { NgModule } from '@angular/core';

import { AuthService } from './common/auth.service';
import { LoginComponent } from './login/login.component';
import { HttpModule } from "@angular/http";
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [
    LoginComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HttpModule
  ],
  providers: [AuthService],
  exports: [LoginComponent]
})

export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/shared/login/login.module.ts